<template>
  <div class="wlx-exam-center-table-wrapper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <div class="head-title-con clearfix">
          <div class="fl basic-book-img-con">
            <img src="~assets/images/basic-book-img.png" alt />
          </div>
          <div class="fr head-title-word">
            <p class="p-title-1">物流行指委下设专业</p>
            <p class="p-title-1">委员会委员申请表</p>
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
          </div>
        </div>
      </div>
    </div>
    <div class="apply-table-content" id="export_word">
      <table border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td class="u-label-title" colspan="2">姓名</td>
          <td colspan="2">
            <el-input v-model="name"></el-input>
          </td>
          <td class="u-label-title" colspan="1">性别</td>
          <td colspan="1">
            <el-select v-model="sex" placeholder>
              <el-option label="男" :value="0"></el-option>
              <el-option label="女" :value="1"></el-option>
            </el-select>
          </td>
          <td class="u-label-title" colspan="2">出生年月</td>
          <td colspan="3">
            <!-- <el-input v-model="dateCreated"></el-input> -->
            <el-date-picker
              v-model="dateCreated"
              type="date"
             placeholder="选择日期">
            </el-date-picker>
          </td>
          <td class="u-label-title" colspan="1">民族</td>
          <td colspan="2">
            <el-input v-model="ancestor"></el-input>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2">单位</td>
          <td colspan="5">
            <el-input v-model="company"></el-input>
          </td>
          <td class="u-label-title" colspan="2">职务职称</td>
          <td colspan="5">
            <el-input v-model="job"></el-input>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2">毕业学校</td>
          <td colspan="5">
            <el-input v-model="school"></el-input>
          </td>
          <td class="u-label-title" colspan="2">学历/学位</td>
          <td colspan="5">
            <el-input v-model="education"></el-input>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2">社会兼职</td>
          <td colspan="5">
            <el-input v-model="socialJob"></el-input>
          </td>
          <td class="u-label-title" colspan="2">目前从事的专业</td>
          <td colspan="5">
            <el-input v-model="major"></el-input>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2">通信地址</td>
          <td colspan="5">
            <el-input v-model="address"></el-input>
          </td>
          <td class="u-label-title" colspan="2">邮政编码</td>
          <td colspan="5">
            <el-input v-model="number"></el-input>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2">手机</td>
          <td colspan="5">
            <el-input v-model="phone" disabled></el-input>
          </td>
          <td class="u-label-title" colspan="2">电子邮箱</td>
          <td colspan="5">
            <el-input v-model="email"></el-input>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2">是否为原专委会委员</td>
          <td colspan="5">
            <el-select v-model="isCommittee" placeholder>
              <el-option label="是" :value="0"></el-option>
              <el-option label="否" :value="1"></el-option>
            </el-select>
          </td>
          <td class="u-label-title" colspan="2">意向加入专业委员会委员</td>
          <td colspan="5">
            <el-select v-model="committeeType" placeholder>
              <el-option
                v-for="(item,index) in committee"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </td>
        </tr>
        <tr>
            <td class="u-label-title" colspan="2" valign="middle">工作简历</td>
            <td colspan="12">
              <el-input type="textarea" :rows="10" v-model="resume"></el-input>
            </td>
          </tr>
          <tr>
            <td class="u-label-title" colspan="2" valign="middle">专委会工作建议</td>
            <td colspan="12">
              <el-input type="textarea" :rows="10" v-model="advise"></el-input>
            </td>
          </tr>
      </table>
    </div>
    <div class="apply-table-contents">
      <div class="submit-apply-btn">
        <el-button type="primary" @click="goBank">返回</el-button>
        <el-button type="primary" @click="submitApply">保存</el-button>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      committeeInfo:"",
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      name:'',
      sex:0,
      dateCreated:'',
      ancestor:'',
      company:'',
      job:'',
      school:'',
      education:'',
      socialJob:'',
      major:'',
      address:'',
      number:'',
      phone:'',
      email:'',
      resume:'',
      advise:'',
      committee:[
          {
              label:'教学改革专业委员会',
              value:1
          },
          {
              label:'技能开发专业委员会',
              value:2
          },
          {
              label:'校企合作专业委员会',
              value:3
          },
          {
              label:'国际合作专业委员会',
              value:4
          },
          {
              label:'信息化专业委员会',
              value:5
          },
          {
              label:'师资建设专业委员会',
              value:6
          },
      ],
      committeeType: 0,
      isCommittee: 0
    };
  },
  props: {
    committeeId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getCommitteeInfo();
  },
  methods: {
    getCommitteeInfo(){
      this.$http
        .post("/api/XOrg/Committee/getCommitteeInfo",{
          id : this.committeeId
        })
        .then(rst => {
          if (rst.code > 0) {
            this.committeeInfo = rst.committeeInfo;
            this.name = rst.committeeInfo.CommitteeName;
            this.sex = rst.committeeInfo.CommitteeSex;
            this.dateCreated = rst.committeeInfo.CommitteeDateCreated;
            this.ancestor = rst.committeeInfo.Ancestor;
            this.company = rst.committeeInfo.Company;
            this.job = rst.committeeInfo.Job;
            this.school = rst.committeeInfo.School;
            this.education = rst.committeeInfo.Education;
            this.socialJob = rst.committeeInfo.SocialJob;
            this.major = rst.committeeInfo.Major;
            this.address = rst.committeeInfo.Address;
            this.number = rst.committeeInfo.Number;
            this.phone = rst.committeeInfo.Phone;
            this.email = rst.committeeInfo.Email;
            this.resume = rst.committeeInfo.Resume;
            this.isCommittee = rst.committeeInfo.IsCommittee;
            this.committeeType = Number(rst.committeeInfo.CommitteeType);
            this.advise = rst.committeeInfo.Advise;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },

    submitApply() {
      const reg = /^1\d{10}$/;
      if (this.name == "") {
        this.$message.warning("请输入姓名");
        return false;
      }
      if (this.sex === "") {
        this.$message.warning("请选择性别");
        return false;
      }
      if (this.dateCreated == "") {
        this.$message.warning("请输入出生年月");
        return false;
      }
      if (this.ancestor == "") {
        this.$message.warning("请输入民族");
        return false;
      }
      if (this.company == "") {
        this.$message.warning("请输入单位");
        return false;
      }
      if (this.job == "") {
        this.$message.warning("请输入职称/职务");
        return false;
      }
      if (this.school == "") {
        this.$message.warning("请输入毕业学校");
        return false;
      }
      if (this.education == "") {
        this.$message.warning("请输入学历/学位");
        return false;
      }
      if(this.socialJob ==""){
        this.$message.warning("请输入社会兼职");
        return false;
      }
      if (this.major == "") {
        this.$message.warning("请输入目前从事的专业");
        return false;
      }
      if (this.address == "") {
        this.$message.warning("请输入通信地址");
        return false;
      }
      if (this.number == "") {
        this.$message.warning("请输入邮政编码");
        return false;
      }
      if (this.phone == "") {
        this.$message.warning("请输入手机号");
        return false;
      }
      if (this.email == "") {
        this.$message.warning("请输入邮政编码");
        return false;
      }
      if (this.isCommittee === "") {
        this.$message.warning("请选择是否为原专委会委员");
        return false;
      }
      if (this.committeeType === "") {
        this.$message.warning("请选择专业委员会委员类型");
        return false;
      }
      // if (this.resume == "") {
      //   this.$message.warning("请输入简介");
      //   return false;
      // }
      this.$http
        .post("/api/XOrg/Committee/editCommitteeInfo", {
          id : this.committeeId,
          name:this.name,
          sex:this.sex,
          dateCreated:this.dateCreated,
          ancestor:this.ancestor,
          company:this.company,
          job:this.job,
          school:this.school,
          education:this.education,
          socialJob:this.socialJob,
          major:this.major,
          address:this.address,
          number:this.number,
          //phone:this.phone,
          email:this.email,
          resume:this.resume,
          isCommittee:this.isCommittee,
          committeeType:this.committeeType,
          advise:this.advise,
        })
        .then(res => {
          if (res.code > 0) {
            this.$message.success(res.msg);
            this.$router.push({
              name: 'committeeManager'
            })
          } else {
            this.$message.warning(res.msg);
            return;
          }
        });
    },
    goBank(){
      this.$router.push({
        name: 'committeeManager'
      })
    },
  },
};
</script>

<style lang="scss">
.apply-table-contents {
  width: 1000px;
  margin: 0 auto;
}
.sp-city-con {
  background: #fff;
  display: inline-block;
  width: 220px;
  line-height: 40px;
  padding: 0 10px;
}
.wlx-exam-center-table-wrapper {
  .el-upload-list {
    background: #fff;
  }
}
</style>
